/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import { negocio } from '../../conexiones';
import IDivisionesTiposPropiedades from './entidades/divisionesTiposPropiedades';

export default class ModeloDivisionesTiposPropiedades {
    public consultarDivisionesTiposPropiedades() {
        return manejadorRest<IRespuesta<IDivisionesTiposPropiedades>>(() =>
            negocio.get('DivisionTipoPropiedad/ConsultarListaDivisionTipoPropiedad')
        );
    }
    public crearDivisionesTiposPropiedades(divisionesTiposPropiedades: IDivisionesTiposPropiedades) {
        return manejadorRest<IRespuesta<IDivisionesTiposPropiedades>>(() =>
            negocio.post('DivisionTipoPropiedad/GuardarDivisionTipoPropiedad', divisionesTiposPropiedades)
        );
    }
    public editarDivisionesTiposPropiedades(divisionesTiposPropiedades: IDivisionesTiposPropiedades) {
        return manejadorRest<IRespuesta<IDivisionesTiposPropiedades>>(() =>
            negocio.put('DivisionTipoPropiedad/EditarDivisionTipoPropiedad', divisionesTiposPropiedades)
        );
    }
    public eliminarDivisionesTiposPropiedades(divisionesTiposPropiedades: IDivisionesTiposPropiedades) {
        return manejadorRest<IRespuesta<IDivisionesTiposPropiedades>>(() =>
            negocio.delete('DivisionTipoPropiedad/EliminarDivisionTipoPropiedad', divisionesTiposPropiedades)
        );
    }

    public consultarPorFiltroDivisionesTiposPropiedades(divisionesTiposPropiedades: Partial<IDivisionesTiposPropiedades>) {
        return manejadorRest<IRespuesta<IDivisionesTiposPropiedades>>(() =>
            negocio.post('DivisionTipoPropiedad/ConsultarDivisionTipoPropiedadPorFiltro', divisionesTiposPropiedades)
        );
    }
}
